import { testErrorListConstants } from "../_redux-constants";
import { testErrorListService } from "../../_services";

function getTestErrorList(queryParams) {
  function getTestErrorListLoad() {
    return { type: testErrorListConstants.TEST_ERRORS_LOADING };
  }
  function testErrorListSuccess(data) {
    return { type: testErrorListConstants.TEST_ERRORS_SUCCESS, data };
  }
  function testErrorListFailure(error) {
    return { type: testErrorListConstants.TEST_ERRORS_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getTestErrorListLoad());
    return testErrorListService.getTestErrorList(queryParams).then(
      (data) => {
        dispatch(testErrorListSuccess(data));
      },
      (error) => {
        dispatch(testErrorListFailure(error));
      }
    );
  };
}

export const testErrorListActions = {
  getTestErrorList,
};
